export default __webpack_public_path__ + "static/insta-hotels-12-25394aaf0a37609981fb137056cfbb40.jpg";